import { gql } from '@apollo/client'

export const CREATE_NICHES_BY_SEARCH = gql`
  mutation createNichesBySearch($pagination: CreateNichesBySearchPaginationInput!, $query: String!) {
    createNichesBySearch(pagination: $pagination, query: $query) {
      cursor
      totalCount
      data {
        territoryId
        name
        ... on Niche {
          parent {
            name
            ... on Topic {
              language
              category {
                title
              }
            }
            ... on Subtopic {
              language
              topic {
                name
              }
            }
          }
        }
      }
    }
  }
`
